import { render } from "./post_manage.vue?vue&type=template&id=3871867d&scoped=true&ts=true"
import script from "./post_manage.vue?vue&type=script&lang=ts"
export * from "./post_manage.vue?vue&type=script&lang=ts"

import "./post_manage.vue?vue&type=style&index=0&id=3871867d&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3871867d"]])

export default __exports__